import AuthStore, { AuthModel } from "store/auth";
import CmsContentStore, { CmsContentModel } from "store/cmsContent";
import ItemStore, { ItemModel } from "store/item";

export interface StoreModel {
  auth: AuthModel;
  item: ItemModel;
  cmsContent: CmsContentModel;
}

const Store: StoreModel = {
  auth: AuthStore,
  item: ItemStore,
  cmsContent: CmsContentStore,
};

export default Store;
